import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import Flashy from "./Flashy.svelte";

export default {
    component: Flashy,
    name: "Flashy Callout",
    description: "Eye-catching callout block with animated styling",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/bolt.svg",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/atoms-flashy--docs`,
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F222e2c92c4e7439a81e070a9ddb83be8",
    inputs: [
        {
            friendlyName: "Title",
            name: "title",
            type: "text",
            required: true,
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Description",
            name: "description",
            type: "longText",
            required: true,
        },
        {
            friendlyName: "CTA Text",
            name: "linkText",
            type: "string",
        },
        {
            friendlyName: "CTA Link",
            name: "linkUrl",
            type: "string",
        },
    ],
};
